// extracted by mini-css-extract-plugin
export default {"productGrid":"Mla-z","centerLink":"Nla-z","productSection":"Ola-z","item":"Pla-z","ctaButton":"Qla-z"};